export default __webpack_public_path__ + "static/media/group-unselected.23329188.png";